import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule, ReactiveFormsModule, FormBuilder } from "@angular/forms";
import { Router, NavigationEnd, RouterOutlet } from "@angular/router";
import { Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { AuthService } from "./security/auth.service";
import { SpinnerOverlayService } from "./security/helper/spinner-overlay.service";
import { TemaService } from "./shared/tema/tema.service";

declare const $: any;

@Component({
  selector: "app-my-app",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    RouterOutlet,
  ],
})
export class AppComponent implements OnInit {
  private _router: Subscription;

  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private authS: AuthService,
    public spinnerOverlayService: SpinnerOverlayService,
    // Se inyecta aqui, aunque no se use, para que el tema guardado se
    // pinte en <html> desde el arranque y no hasta que alguien abra el
    // selector.
    private tema: TemaService
  ) {}

  ngOnInit() {
    // Limpia backdrop de modales al navegar
    this._router = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        const body = document.body;
        const modalBackdrop = document.querySelector(".modal-backdrop");
        if (body.classList.contains("modal-open")) {
          body.classList.remove("modal-open");
          modalBackdrop?.remove();
        }
      });

    // Configuracion global DataTable
    $.extend(true, $.fn.dataTable.defaults, {
      searching: false,
      bSort: false,
      pagingType: "full_numbers",
      lengthMenu: [5, 10, 20, 50, 100],
      language: {
        emptyTable: "Datos no disponibles",
        loadingRecords: "Cargando...",
        processing: "Procesando...",
        search: "Buscar:",
        lengthMenu: "Mostrando _MENU_ registros por pag.",
        zeroRecords: "No se encontro informacion",
        info: "Pag. _PAGE_ de _PAGES_",
        infoEmpty: "Sin registros",
        paginate: {
          first: "Inicio",
          last: "Ultimo",
          next: "Siguiente",
          previous: "Anterior",
        },
      },
    });
  }
}
